module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_8004.1ba8ac89.png";